<script setup lang="ts">
import type {
  CmsBlockSidebarFilter,
  CmsElementSidebarFilter,
} from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockSidebarFilter;
}>();

const { getSlotContent } = useCmsBlock(props.content);
const slotContent = getSlotContent("content") as CmsElementSidebarFilter;

// Track if there's more content to scroll using VueUse
const sidebarFilterRef = ref<HTMLElement | null>(null);
const { arrivedState } = useScroll(sidebarFilterRef, {
  offset: { bottom: 10 }
});

// Show gradient when not arrived at bottom
const showBottomGradient = computed(() => !arrivedState.bottom);
</script>
<template>
  <div
    ref="sidebarFilterRef"
    class="sidebar-filter max-h-[100vh] lg:max-h-[95vh] lg:h-auto overflow-y-auto bg-white fixed inset-0 lg:sticky lg:top-[24px] tall:top-[200px] tall:max-h-[79vh] z-[45] lg:z-0 w-[85%] md:w-3/6 lg:w-[272px] xl:w-[287px] 2xl:w-[300px] 3xl:w-[375px] lg:pr-7 xl:pr-10 -translate-x-full lg:translate-x-0 transition-all duration-300 ease-in-out custom-scrollbar lg:bg-transparent lg:!-mr-1"

    role="complementary"
    :aria-label="$t('productListing.ariaLabelListingFilters')">
    <CmsElementSidebarFilter :content="slotContent" />
    <div v-if="showBottomGradient" class="sidebar-filter-fade"></div>
  </div>
</template>

<style scoped>
.sidebar-filter-fade {
  position: sticky;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 96px;
  background: linear-gradient(to top, white 0%, rgba(255, 255, 255, 0.8) 50%, transparent 100%);
  pointer-events: none;
  z-index: 10;
  margin-top: -96px;
}
</style>
